import { render, staticRenderFns } from "./PaymentMethodChoiceDialog.vue?vue&type=template&id=556b72d0&"
import script from "./PaymentMethodChoiceDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodChoiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodChoiceDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports